import { render } from "./RegisterStep1.vue?vue&type=template&id=0cedfa06&scoped=true"
import script from "./RegisterStep1.vue?vue&type=script&lang=js"
export * from "./RegisterStep1.vue?vue&type=script&lang=js"

import "./RegisterStep1.vue?vue&type=style&index=0&id=0cedfa06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cedfa06"]])

export default __exports__